import { useLocation } from 'react-router'
import { Banner, Modal, Toast } from 'shared/ui'
import { APP_TYPE } from 'shared/config'
import { IdleManager } from 'entities/Auth/ui/IdleManager'
import { PresentationMode } from 'widgets/PresentationMode/ui/PresentationMode'
import { CallPopUp } from 'widgets/CallPopUp'
import { GlobalBanners } from 'widgets/GlobalBanners/GlobalBanners'
import { PageNotFoundRoutes } from 'pages/pageNotFound/route/type'
import { SuspendedRoutes } from 'pages/suspended/route/type'
import { GlobalEvents } from 'app/shared/ui/GlobalEvents'
import { RetentlyLayout } from './RetentlyLayout'

export const CommonLayout = () => {
  const location = useLocation()
  const onlyForReactApp = APP_TYPE === 'react' || APP_TYPE === 'light'
  const isVueApp = APP_TYPE === 'vue'
  const isSuspendedPage = location.pathname.startsWith(`/${SuspendedRoutes.root}`)
  const isPageNotFoundPage = location.pathname === `/${PageNotFoundRoutes.root}`

  return (
    <>
      {!isVueApp && <GlobalEvents />}
      <Toast />
      <PresentationMode />
      <RetentlyLayout />
      {!isVueApp && <IdleManager />}
      {onlyForReactApp && (
        <>
          {!isSuspendedPage && !isPageNotFoundPage && <Banner globalBanners={<GlobalBanners />} />}
          <Modal />
          <CallPopUp />
        </>
      )}
    </>
  )
}
